import BaseProductVariant, { IBaseProductVariant } from './BaseProductVariant'
import PRODUCT_VARIANT_DOMAIN_TYPES from './ProductVariantDomainTypes'

type IProductVariant = IBaseProductVariant

export default class ProductVariant extends BaseProductVariant implements IProductVariant {
  constructor(iProductVariant: IProductVariant) {
    super(iProductVariant, PRODUCT_VARIANT_DOMAIN_TYPES.PRODUCT_VARIANT)
    return {
      ...this,
    }
  }
}
